import createSellerAccount from '../Pages/Home/CreateSellerAccount';
import HomePage from '../Pages/Home/HomePage';
import AddProduct from '../Pages/Store/AddProduct';
import Dashboard from '../Pages/Store/Dashboard';
import Products from '../Pages/Store/Products';
import StoreRoot from '../Pages/Store/StoreRoot';
import { MdDashboard } from 'react-icons/md';
import { HiBuildingStorefront } from 'react-icons/hi2';
import { FaShoppingCart } from 'react-icons/fa';
import { LuLayoutList } from 'react-icons/lu';
import StoreAccount from '../Pages/Store/StoreAccount';
import Orders from '../Pages/Home/Orders';
import ViewProduct from '../Pages/Store/ViewProduct';
import CheckOut from '../Pages/Store/CheckOut';
import Cart from '../Pages/Store/Cart';
import WishList from '../Pages/Home/WishList';
import Shopping from '../Pages/Home/Shopping';
import StoreOrders from '../Pages/Store/StoreOrders';
import ProductReview from '../Pages/Store/ProductReview';
import OfferZone from '../Pages/Store/OfferZone';
import Profile from '../Pages/Home/Profile';
import ContactUs from '../Pages/Home/ContactUs';
import AddPickupPoints from '../Pages/Store/AddPickupPoints';
import { TbTruckDelivery } from 'react-icons/tb';
import AddAddress from '../Pages/Home/AddAddress';
import CreateAddress from '../Pages/Home/CreateAddress';
import EditProduct from '../Pages/Store/EditProduct';
import StoreFront from '../Pages/Store/StoreFront';

export const HomeRoutes = [
    {
        link: '/',
        component: HomePage,
        roles: ['buyer'],
    },
    {
        link: '/createSellerAccount',
        component: createSellerAccount,
        roles: ['buyer'],
    },
    {
        link: '/store/:storeId/*',
        component: StoreRoot,
        roles: ['buyer'],
    },
    {
        link: '/product/:productId/view',
        title: 'View Product',
        sideBar: false,
        component: ViewProduct,
        roles: ['buyer'],
    },
    {
        link: '/product/checkOut',
        title: 'Check Out',
        sideBar: false,
        component: CheckOut,
        roles: ['buyer'],
    },
    {
        link: '/cart',
        title: 'Shopping Cart',
        sideBar: false,
        component: Cart,
        roles: ['buyer'],
    },
    {
        link: '/wishlist',
        title: 'Wishlist',
        sideBar: false,
        component: WishList,
        roles: ['buyer'],
    },
    {
        link: '/orders',
        title: 'Orders',
        sideBar: false,
        component: Orders,
        roles: ['buyer'],
    },
    {
        link: '/shopping/category/:categoryId',
        title: 'View Product',
        sideBar: false,
        component: Shopping,
        roles: ['buyer'],
    },
    {
        link: '/shopping/categoryByPrice/:priceType',
        title: 'View Product',
        sideBar: false,
        component: Shopping,
        roles: ['buyer'],
    },
    {
        link: '/product/:productId/review',
        title: 'Create Review',
        sideBar: false,
        component: ProductReview,
        roles: ['buyer'],
    },
    {
        link: '/product/offerZone',
        title: 'Offer Zone',
        sideBar: false,
        component: OfferZone,
        roles: ['buyer'],
    },
    {
        link: '/account',
        title: 'Account',
        sideBar: false,
        component: Profile,
        roles: ['buyer', 'seller'],
    },
    {
        link: '/contactUs',
        title: 'Contact Us',
        sideBar: false,
        component: ContactUs,
        roles: ['buyer', 'seller'],
    },
    {
        link: '/addAddress',
        title: 'Add Address',
        sideBar: false,
        component: AddAddress,
        roles: ['buyer'],
    },
    {
        link: '/createAddress',
        title: 'Add Address',
        sideBar: false,
        component: CreateAddress,
        roles: ['buyer'],
    },
    {
        link: '/brand/:storeId/viewProducts',
        title: 'Store Front',
        sideBar: false,
        component: StoreFront,
    },
];

export const StoreRoutes = [
    {
        link: '/store/:storeId/' || '/store/:storeId/dashboard',
        title: 'Dashboard',
        icon: MdDashboard,
        sideBar: true,
        component: Dashboard,
    },
    {
        link: '/store/:storeId/products',
        title: 'Products',
        icon: LuLayoutList,
        sideBar: true,
        component: Products,
    },
    {
        link: '/store/:storeId/orders',
        title: 'Orders',
        icon: FaShoppingCart,
        sideBar: true,
        component: StoreOrders,
    },
    {
        link: '/store/:storeId/account',
        title: 'Account',
        icon: HiBuildingStorefront,
        sideBar: true,
        component: StoreAccount,
    },
    {
        link: '/store/:storeId/addProduct',
        title: 'Add Product',
        sideBar: false,
        component: AddProduct,
    },
    {
        link: '/store/:storeId/addPickupPoints',
        title: 'Add Pickup Points',
        sideBar: true,
        icon: TbTruckDelivery,
        component: AddPickupPoints,
    },
    {
        link: '/store/:storeId/editProduct/:prodId',
        title: 'Edit Product',
        sideBar: false,
        component: EditProduct,
    },
];

export const CombinedRoutes = [...HomeRoutes];
